import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
} from '@mui/material';
import {
  AccountCircle,
  Dashboard as DashboardIcon,
  ExitToApp,
} from '@mui/icons-material';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    handleClose();
  };

 return (
  <Box sx={{ flexGrow: 1 }}>
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Toolbar sx={{ py: 1.5 }}>
        {/* LOGO / TITLE */}
        <Box
          role="button"
          tabIndex={0}
          aria-label="Go to home"
          onClick={() => navigate('/')}
          onKeyDown={(e) => { if (e.key === 'Enter') navigate('/'); }}
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            fontWeight: 900,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#1e40af',
            letterSpacing: 0.5,
            outline: 'none',
            '&:focus': { boxShadow: '0 0 0 3px rgba(37,99,235,0.12)', borderRadius: 1 },
          }}
        >
          <Box
            component="img"
            src="/images/videsaloho.png"
            alt="Videsa logo"
            sx={{ height: 90, width: 'auto', objectFit: 'contain', display: 'block' }}
          />
          <Typography
            variant="h6"
            sx={{ display: { xs: 'none', sm: 'block' }, color: '#1e40af', fontWeight: 900 }}
          >
            VIDESA
          </Typography>
        </Box>

        {isAuthenticated ? (
          <>
            {/* DASHBOARD BUTTON */}
            <Button
              startIcon={<DashboardIcon />}
              onClick={() => navigate('/dashboard')}
              sx={{
                mr: 2,
                color: '#1e40af',
                fontWeight: 600,
                borderRadius: 2,
                px: 2,
                '&:hover': {
                  bgcolor: 'rgba(30,64,175,0.08)',
                },
              }}
            >
              Dashboard
            </Button>

            {/* USER MENU */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  display: { xs: 'none', sm: 'block' },
                  fontWeight: 600,
                  color: '#1f2937',
                }}
              >
                {user?.name}
              </Typography>

              <IconButton
                size="large"
                onClick={handleMenu}
                sx={{
                  color: '#1e40af',
                  bgcolor: 'rgba(30,64,175,0.08)',
                  '&:hover': {
                    bgcolor: 'rgba(30,64,175,0.15)',
                  },
                }}
              >
                <AccountCircle />
              </IconButton>
            </Box>

            {/* DROPDOWN MENU */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  mt: 1.5,
                  borderRadius: 3,
                  minWidth: 220,
                  p: 1,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
                },
              }}
            >
              <MenuItem disabled sx={{ opacity: 1 }}>
                <Box>
                  <Typography fontWeight={700}>
                    {user?.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#64748b' }}>
                    {user?.role?.toUpperCase()}
                  </Typography>
                </Box>
              </MenuItem>

              <MenuItem
                onClick={handleLogout}
                sx={{
                  mt: 0.5,
                  borderRadius: 2,
                  color: 'error.main',
                  '&:hover': {
                    bgcolor: 'rgba(239,68,68,0.08)',
                  },
                }}
              >
                <ExitToApp sx={{ mr: 1 }} />
                Logout
              </MenuItem>
            </Menu>
          </>
        ) : (
          <>
            {/* SIGN IN */}
            <Button
              onClick={() => navigate('/login')}
              sx={{
                mr: 1.5,
                color: '#1e40af',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: 'rgba(30,64,175,0.08)',
                },
              }}
            >
              Sign In
            </Button>

            {/* REGISTER */}
            <Button
              variant="contained"
              sx={{
                bgcolor: '#2563eb',
                color: 'white',
                fontWeight: 700,
                px: 3,
                borderRadius: 999,
                boxShadow: '0 10px 20px rgba(37,99,235,0.35)',
                '&:hover': {
                  bgcolor: '#1e40af',
                },
              }}
              onClick={() => navigate('/register')}
            >
              Register
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  </Box>
);
};

export default Navbar;
